import {DiceSettingEnum} from '@colonist/types'
import {PlayerEnums} from '../../../../shared/GameEnums'
import {StorageWrapper} from '../StorageWrapper'
import {socket} from '../EntryShared.ts'

export class UIRoomSettingsController {
    static initRoomSettingFromLocalStorage(): void {
        const diceSetting = UIRoomSettingsController.getLocalStorageDiceSettings()
        if(diceSetting != undefined) socket.roomClient.setDiceType(diceSetting)

        const friendlyRobberActive = UIRoomSettingsController.getLocalStorageFriendlyRobberSettings()
        if(friendlyRobberActive != undefined) socket.roomClient.setFriendlyRobber(friendlyRobberActive)

        const gameSpeedSetting = UIRoomSettingsController.getLocalStorageGameSpeedSettings()
        if(gameSpeedSetting != undefined) {
            socket.roomClient.setGameSpeed(gameSpeedSetting)
        }

        const botSpeedSetting = UIRoomSettingsController.getLocalStorageBotSpeedSettings()
        if(botSpeedSetting != undefined) {
            socket.roomClient.setBotSpeed(botSpeedSetting)
        }
    }

    private static getLocalStorageDiceSettings(): DiceSettingEnum | undefined {
        const diceSetting = StorageWrapper.getRoomDiceSetting()
        if(diceSetting == null) return undefined
        return diceSetting
    }

    private static getLocalStorageFriendlyRobberSettings(): boolean | undefined {
        const friendlyRobberActive = StorageWrapper.getRoomFriendlyRobberActiveSetting()
        if(friendlyRobberActive == null) return undefined
        return friendlyRobberActive
    }

    private static getLocalStorageGameSpeedSettings(): PlayerEnums.GameSpeedSettings | undefined {
        const gameSpeedSetting = StorageWrapper.getRoomGameSpeedSetting()
        if(gameSpeedSetting == null) return undefined
        return gameSpeedSetting
    }

    private static getLocalStorageBotSpeedSettings(): PlayerEnums.BotSpeedSettings | undefined {
        const botSpeedSetting = StorageWrapper.getRoomBotSpeedSetting()
        if(botSpeedSetting == null) return undefined
        return botSpeedSetting
    }
}
